export enum LlmTaskStatus {
	COMPLETE = 'complete',
	FAILED = 'failed',
	NONE = 'none',
	PROCESSING = 'processing',
	QUEUED = 'queued'
}

export enum LlmRelations {
	SESSION = 'Session'
}

export enum LlmFeatures {
	AI_COMMENTS = 'ai_comments',
	AUTO_GRADED_RUBRICS = 'auto_graded_rubrics'
}

export interface LlmTask {
	llm_definition_id: number;
	started_at: string;
	finished_at: string;
	status: LlmTaskStatus;
}
